import React, { FC, PropsWithChildren } from "react";
import {
  FormControl,
  FormControlProps,
  FormLabel,
  RadioGroup,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { ControllerProps } from "react-hook-form";

interface ReactHookFormRadioButtonGroupProps extends FormControlProps {
  label: string;
  controller: Omit<ControllerProps<any>, "render">;
}

const ReactHookFormRadioButtonGroup: FC<
  PropsWithChildren<ReactHookFormRadioButtonGroupProps>
> = ({ label, controller, children, ...props }) => {
  const labelId = `${controller.name}-label`;
  return (
    <FormControl {...props}>
      <FormLabel id={labelId}>{label}</FormLabel>
      <Controller
        render={({ field }) => (
          <RadioGroup
            {...field}
            aria-labelledby={labelId}
            defaultValue={controller.defaultValue}
          >
            {children}
          </RadioGroup>
        )}
        {...controller}
      />
    </FormControl>
  );
};

export default ReactHookFormRadioButtonGroup;
